module.exports = __webpack_public_path__ + "img/IMG_6070_L_Black_MockedUp.4eaf98d6.jpg";